import { Observable, timer } from 'rxjs';
import { retry, switchMap, take } from 'rxjs/operators';

export default function poll<T>(
  observable: Observable<T>,
  pollingInterval: number,
  immediate = false,
): Observable<T> {
  return timer(immediate ? 0 : pollingInterval, pollingInterval).pipe(
    switchMap(() => observable.pipe(take(1))),
    retry({
      delay: 5000,
    }),
  );
}
